
import { useSiteSettings } from "@/hooks/useSiteSettings";

interface DynamicContactSectionProps {
  title: string;
  subject?: string;
}

const DynamicContactSection = ({ title, subject }: DynamicContactSectionProps) => {
  const { data: settings } = useSiteSettings();

  // Fallback to default values if settings are not available
  const legalEmail = settings?.legal_email || "legal@boboteedee.ky";
  const legalPhone = settings?.legal_phone || "+1 (345) 123-4567";
  const legalAddress = settings?.legal_address || "Bobo & Teedee® Legal Department, Grand Cayman, Cayman Islands";

  return (
    <div>
      <p className="text-gray-700 leading-relaxed">
        If you have questions about {title.toLowerCase()}, please contact us:
      </p>
      <div className="bg-gray-50 p-4 rounded-lg">
        <p className="text-gray-700">
          <strong>Email:</strong> {legalEmail}<br />
          {subject && (
            <>
              <strong>Subject Line:</strong> {subject}<br />
            </>
          )}
          <strong>Phone:</strong> {legalPhone}<br />
          <strong>Address:</strong> {legalAddress}
        </p>
      </div>
    </div>
  );
};

export default DynamicContactSection;
